import React, { useState } from 'react';
import './navbar.css';
import { Link } from 'react-scroll';
import logo from '../../assets/logo.png';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      <nav className="navbar">
        <div className="logo d-block d-lg-none">
        <img src={logo} alt='' className='logo rounded' />
        </div>
        <div className="desktopMenu">
          <Link to="home" smooth={true} duration={500} className="desktopMenuListItem">Home</Link>
          <Link to="skills" smooth={true} duration={500} className="desktopMenuListItem">About</Link>
          <Link to="Experience" smooth={true} duration={500} className="desktopMenuListItem">Experience</Link>
          <Link to="Works" smooth={true} duration={500} className="desktopMenuListItem">Portfolio</Link>
          <Link to="contact" smooth={true} duration={500} className="desktopMenuListItem">Contact</Link>
        </div>
        <div className="hamburger" onClick={toggleMobileMenu}>
          &#9776; {/* Hamburger icon */}
        </div>
        <div className={`mobileMenu ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to="home" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>Home</Link>
          <Link to="skills" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>About</Link>
          <Link to="Experience" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>Experience</Link>
          <Link to="contact" smooth={true} duration={500} className="mobileMenuListItem" onClick={toggleMobileMenu}>Contact</Link>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
